import BePrepared from './BePrepared';

export default BePrepared;